// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef } from 'react';

function useOnUnmount(callback) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => () => callbackRef.current(), []);
}

export default useOnUnmount;
